// helper to wrap segment analytics calls.
export const segmentTracker = {
  track: (event: string, properties?: Record<string, unknown>) =>
    window.analytics.track(event, properties),

  page: (name: string, properties?: Record<string, unknown>) =>
    window.analytics.page(name, properties),

  identify: (userId: number | string, traits?: Record<string, unknown>) =>
    window.analytics.identify(userId, traits),

  group: (groupId: string, traits?: Record<string, unknown>) =>
    window.analytics.group(groupId, traits),

  reset: () => window.analytics.reset(),

  user: () => window.analytics.user?.(),
};
